import { useMutation, useQueryClient } from '@tanstack/react-query'
import { bulkCreateCohorts } from '@/services/cohorts'
import type { CohortCreate } from '@/types'

export function useBulkCreateCohorts() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (cohorts: CohortCreate[]) => bulkCreateCohorts(cohorts),
    onSuccess: (data) => {
      const districtIds = [...new Set(data.map((c) => c.district_id))]
      districtIds.forEach((districtId) => {
        queryClient.invalidateQueries({ queryKey: ['cohorts', 'district', districtId] })
      })
      queryClient.invalidateQueries({ queryKey: ['cohorts', 'nation'] })
    },
  })

  return {
    bulkCreateCohorts: mutation.mutate,
    bulkCreateCohortsAsync: mutation.mutateAsync,
    isCreating: mutation.isPending,
    error: mutation.error,
  }
}
